import request from '@/router/axios'

export function diagnosisPage(data) {
  return request({
    url: '/chain/companyDiagnosis/diagnosisPage',
    method: 'post',
    data: data
  })
}
export function diagnosisExportExcel(data) {
  return request({
    url: '/chain/companyDiagnosis/diagnosisExportExcel',
    method: 'post',
    data: data
  })
}